import React from "react";
import { Route, Routes } from "react-router-dom";
import Dashboard from "../../../Pages/Dashboard/Dashboard";
import Respondents from "../../../Pages/Respondents/Respondents";
import InvitationReminder from "../../../Pages/SiteContent/InvitationReminder";
import ManageSubmissionCycle from "../../../Pages/SiteContent/ManageSubmissionCycle";
import ManageEmailTemplate from "../../../Pages/SiteContent/ManageEmailTemplate";
import ManagePolicyContent from "../../../Pages/SiteContent/ManagePolicyContent";
import ManagePolicyAndEmailSetting from "../../../Pages/SiteContent/ManagePolicyAndEmailSetting";
import ViewArchives from "../../../Pages/SiteContent/ViewArchives";
import ManageAdminPermission from "../../../Pages/SiteContent/ManageAdminPermission";
import ManageFormLabels from "../../../Pages/SiteContent/ManageFormLabels";
import ManageEntity from "../../../Pages/SiteContent/ManageEntity";
import SitePermission from "../../../Pages/SiteContent/SitePermission";
import AddNewFormLevel from "../../../Pages/SiteContent/AddNewFormLevel";
import ManagePolicyContentHome from "../../../Pages/SiteContent/ManagePolicyContentHome";
import ManageEmailTemplateHome from "../../../Pages/SiteContent/ManageEmailTemplateHome";
import NewPolicyAndEmailSettingHome from "../../../Pages/SiteContent/NewPolicyAndEmailSettingHome";
import AddNewPermission from "../../../Pages/SiteContent/AddNewPermission";
import AddNewEntity from "../../../Pages/SiteContent/AddNewEntity";
const DcoiRoutes = () => {
  return (
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/respondents" element={<Respondents />} />
        <Route path="/sitecontent/SendInvitationReminder" element={<InvitationReminder />} />
        <Route path="/sitecontent/ManageSubmissionCycle" element={<ManageSubmissionCycle />} />
        <Route path="/sitecontent/ManageEmailTemplate" element={<ManageEmailTemplate />} />
        <Route path="/sitecontent/ManageEmailTemplateHome" element={<ManageEmailTemplateHome />} />
        <Route path="/sitecontent/ViewArchives" element={<ViewArchives/>}/>
        <Route path="/sitecontent/InvitationReminder" element={<InvitationReminder/>}/>
        <Route path="/sitecontent/ManagePolicyContent" element={<ManagePolicyContent/>}/>
        <Route path="/sitecontent/ManagePolicyContentHome" element={<ManagePolicyContentHome/>}/>
        <Route path="/sitecontent/ManagePolicyAndEmailSetting" element={<ManagePolicyAndEmailSetting/>}/>
        <Route path="/sitecontent/NewPolicyAndEmailSettingHome" element={<NewPolicyAndEmailSettingHome/>}/>
        <Route path="/sitecontent/ManageAdminPermission" element={<ManageAdminPermission/>}/>
        <Route path="/sitecontent/AddNewPermission" element={<AddNewPermission/>}/>
        <Route path="/sitecontent/ManageFormLabels" element={<ManageFormLabels/>}/>
        <Route path="/sitecontent/ManageEntity" element={<ManageEntity/>}/>
        <Route path="/sitecontent/SitePermission" element={<SitePermission/>}/>
        <Route path="/sitecontent/ManageFormLabels/NewFormLabel" element={<AddNewFormLevel/>}/>
        <Route path="/sitecontent/AddNewEntity" element={<AddNewEntity/>}/>        
      </Routes>
  );
};

export default DcoiRoutes;
